var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutomation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 170,
    viewBox: "0 0 255 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_345_396)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_345_396)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_345_396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.122 81.7049C153.122 66.9141 141.101 54.9238 126.272 54.9238C111.443 54.9238 99.4219 66.9141 99.4219 81.7049C99.4219 96.4957 111.443 108.486 126.272 108.486C141.101 108.486 153.122 96.4957 153.122 81.7049Z",
    stroke: "#484848",
    strokeWidth: 0.908983,
    strokeDasharray: "1.82 1.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.427 81.7046C180.427 51.8723 156.181 27.6885 126.272 27.6885C96.3632 27.6885 72.1172 51.8723 72.1172 81.7046C72.1172 111.537 96.3632 135.721 126.272 135.721C156.181 135.721 180.427 111.537 180.427 81.7046Z",
    stroke: "#484848",
    strokeWidth: 0.908983,
    strokeDasharray: "1.82 1.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.732 81.7052C207.732 36.8315 171.261 0.454102 126.272 0.454102C81.2833 0.454102 44.8125 36.8315 44.8125 81.7052C44.8125 126.579 81.2833 162.956 126.272 162.956C171.261 162.956 207.732 126.579 207.732 81.7052Z",
    stroke: "#484848",
    strokeWidth: 0.908983,
    strokeDasharray: "1.82 1.82"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_345_396)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_345_396)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_345_396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.475 26.9482H134.313C127.892 26.9482 122.688 32.153 122.688 38.5735V62.7358C122.688 69.1562 127.892 74.361 134.313 74.361H158.475C164.895 74.361 170.1 69.1562 170.1 62.7358V38.5735C170.1 32.153 164.895 26.9482 158.475 26.9482Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.475 26.9482H134.313C127.892 26.9482 122.688 32.153 122.688 38.5735V62.7358C122.688 69.1562 127.892 74.361 134.313 74.361H158.475C164.895 74.361 170.1 69.1562 170.1 62.7358V38.5735C170.1 32.153 164.895 26.9482 158.475 26.9482Z",
    fill: "#343B4E"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_345_396)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.683 36.9935L136.242 38.115C135.074 38.2012 134.656 39.0207 134.656 39.9696V56.3594C134.656 57.0926 134.907 57.7396 135.533 58.559L138.913 63.1309C139.456 63.8642 139.998 64.0367 141.042 63.9504L157.82 62.9153C159.239 62.829 159.656 62.1389 159.656 60.9744V42.5143C159.656 41.9105 159.448 41.738 158.738 41.2204C158.696 41.1773 158.655 41.1773 158.613 41.1341L154.022 37.813C152.937 36.9504 152.478 36.8642 150.683 36.9935ZM141.418 42.2124C140.04 42.2987 139.748 42.3418 138.955 41.6517L136.993 40.0558C136.785 39.8402 136.868 39.5814 137.411 39.5383L151.309 38.5031C152.478 38.4169 153.062 38.805 153.521 39.1932L155.9 40.9616C156.025 41.0047 156.276 41.3066 155.942 41.3066L141.584 42.2124H141.418ZM139.832 60.8019V45.1453C139.832 44.4552 140.04 44.1533 140.625 44.1102L157.11 43.1181C157.653 43.075 157.903 43.4201 157.903 44.1102V59.6373C157.903 60.3274 157.778 60.8881 156.902 60.9312L141.125 61.8801C140.249 61.9664 139.832 61.6213 139.832 60.8019ZM155.399 46.0079C155.483 46.4824 155.399 46.9568 154.94 46.9999L154.189 47.1725V58.7316C153.521 59.1197 152.937 59.2923 152.436 59.2923C151.643 59.2923 151.434 59.0335 150.808 58.2571L145.8 50.1485V57.9552L147.386 58.3434C147.386 58.3434 147.386 59.2923 146.134 59.2923L142.628 59.5079C142.544 59.2923 142.628 58.7747 142.962 58.6884L143.88 58.4297V48.0782L142.628 47.9488C142.544 47.4744 142.795 46.7843 143.504 46.7412L147.261 46.4824L152.436 54.6773V47.4312L151.1 47.2587C151.017 46.698 151.392 46.2667 151.893 46.2236L155.399 46.0079Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_345_396)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_345_396)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_345_396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.194 78.5176H79.0315C72.611 78.5176 67.4062 83.7224 67.4062 90.1428V114.305C67.4062 120.726 72.611 125.93 79.0315 125.93H103.194C109.614 125.93 114.819 120.726 114.819 114.305V90.1428C114.819 83.7224 109.614 78.5176 103.194 78.5176Z",
    fill: "#343B4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.194 78.5176H79.0315C72.611 78.5176 67.4062 83.7224 67.4062 90.1428V114.305C67.4062 120.726 72.611 125.93 79.0315 125.93H103.194C109.614 125.93 114.819 120.726 114.819 114.305V90.1428C114.819 83.7224 109.614 78.5176 103.194 78.5176Z",
    stroke: "#484848",
    strokeWidth: 0.910926
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M105.481 99.4561C105.856 98.3453 105.986 97.1683 105.862 96.0038C105.739 94.8393 105.365 93.7143 104.765 92.7041C103.876 91.176 102.517 89.9662 100.886 89.2492C99.2547 88.5322 97.4347 88.3452 95.6887 88.715C94.9012 87.8393 93.9333 87.1396 92.8496 86.6628C91.766 86.186 90.5916 85.9431 89.4051 85.9504C87.6201 85.9461 85.8798 86.5013 84.4351 87.5358C82.9903 88.5703 81.9159 90.0308 81.3665 91.7066C80.2034 91.9414 79.1046 92.4187 78.1437 93.1065C77.1827 93.7943 76.3818 94.6768 75.7945 95.6948C74.8984 97.2187 74.5159 98.9841 74.7023 100.736C74.8886 102.489 75.6341 104.137 76.8313 105.444C76.4563 106.555 76.3262 107.732 76.4497 108.897C76.5731 110.062 76.9472 111.187 77.547 112.197C78.4364 113.725 79.7947 114.935 81.426 115.652C83.0573 116.369 84.8772 116.556 86.6233 116.186C87.4109 117.062 88.3791 117.761 89.4629 118.238C90.5467 118.715 91.7211 118.957 92.9077 118.95C94.6936 118.955 96.4348 118.399 97.8801 117.364C99.3254 116.329 100.4 114.867 100.949 113.19C102.112 112.956 103.21 112.478 104.171 111.79C105.132 111.103 105.933 110.22 106.52 109.202C107.415 107.678 107.797 105.914 107.61 104.162C107.423 102.411 106.678 100.763 105.481 99.4561ZM92.9102 116.795C91.4439 116.797 90.0235 116.29 88.8976 115.364C88.9486 115.336 89.038 115.289 89.0957 115.253L95.7547 111.458C95.9221 111.364 96.0611 111.228 96.1574 111.064C96.2536 110.899 96.3037 110.712 96.3024 110.522V101.258L99.1168 102.862C99.1317 102.869 99.1444 102.88 99.1541 102.893C99.1637 102.906 99.1699 102.922 99.172 102.938V110.61C99.17 112.249 98.5097 113.82 97.3358 114.979C96.1619 116.138 94.5702 116.791 92.9094 116.794L92.9102 116.795ZM79.4434 111.119C78.7091 109.867 78.4445 108.4 78.6959 106.975C78.746 107.004 78.8313 107.056 78.894 107.091L85.553 110.886C85.719 110.982 85.9077 111.032 86.0999 111.032C86.292 111.032 86.4807 110.982 86.6467 110.886L94.7773 106.254V109.462C94.7782 109.478 94.7751 109.495 94.7681 109.51C94.7611 109.524 94.7504 109.537 94.7372 109.547L88.0054 113.383C86.5654 114.201 84.8551 114.422 83.2499 113.998C81.6447 113.573 80.2757 112.538 79.4434 111.119ZM77.6917 96.7748C78.4231 95.5208 79.5784 94.5608 80.9551 94.0629C80.9551 94.119 80.9518 94.2197 80.9518 94.289V101.88C80.9507 102.07 81.0008 102.256 81.0969 102.42C81.193 102.584 81.3316 102.72 81.4986 102.814L89.6284 107.446L86.8139 109.05C86.8 109.059 86.784 109.064 86.7673 109.066C86.7507 109.067 86.7339 109.064 86.7186 109.058L79.9852 105.22C78.5477 104.398 77.499 103.048 77.069 101.465C76.6391 99.8814 76.863 98.1954 77.6917 96.7748ZM100.818 102.086L92.6869 97.453L95.5022 95.8499C95.5161 95.841 95.532 95.8356 95.5484 95.8342C95.5649 95.8328 95.5815 95.8353 95.5967 95.8417L102.329 99.6764C103.361 100.264 104.201 101.13 104.752 102.172C105.303 103.214 105.541 104.39 105.44 105.561C105.338 106.732 104.901 107.85 104.178 108.784C103.456 109.719 102.479 110.431 101.361 110.837V103.019C101.363 102.83 101.313 102.644 101.217 102.48C101.122 102.316 100.984 102.18 100.818 102.086ZM103.619 97.9249C103.554 97.8849 103.488 97.8461 103.421 97.8086L96.7614 94.0134C96.5955 93.9179 96.4068 93.8675 96.2146 93.8675C96.0225 93.8675 95.8338 93.9179 95.6678 94.0134L87.538 98.6451V95.4374C87.5371 95.4211 87.5402 95.4048 87.5472 95.3899C87.5542 95.3751 87.5649 95.3622 87.5781 95.3524L94.3091 91.5202C95.3404 90.9331 96.5199 90.648 97.7095 90.6982C98.8991 90.7485 100.05 91.132 101.026 91.8039C102.003 92.4759 102.766 93.4084 103.225 94.4924C103.684 95.5763 103.82 96.767 103.619 97.9249ZM86.007 103.642L83.1918 102.038C83.1771 102.03 83.1645 102.02 83.155 102.006C83.1455 101.993 83.1395 101.978 83.1374 101.962V94.2898C83.1384 93.1149 83.4785 91.9646 84.1179 90.9735C84.7572 89.9824 85.6695 89.1915 86.7478 88.6933C87.8261 88.1951 89.0259 88.0102 90.2068 88.1603C91.3877 88.3105 92.5009 88.7893 93.4161 89.5409C93.3496 89.5765 93.2838 89.6133 93.2187 89.6515L86.5589 93.4466C86.3919 93.5404 86.2533 93.6763 86.1572 93.8404C86.0611 94.0046 86.011 94.191 86.0121 94.3805L86.007 103.642ZM87.5363 100.388L91.1568 98.325L94.779 100.388V104.513L91.1577 106.575L87.5363 104.513V100.388Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_345_396)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_345_396)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_345_396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.358 88.541H148.196C141.775 88.541 136.57 93.7458 136.57 100.166V124.329C136.57 130.749 141.775 135.954 148.196 135.954H172.358C178.778 135.954 183.983 130.749 183.983 124.329V100.166C183.983 93.7458 178.778 88.541 172.358 88.541Z",
    fill: "#343B4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.358 88.541H148.196C141.775 88.541 136.57 93.7458 136.57 100.166V124.329C136.57 130.749 141.775 135.954 148.196 135.954H172.358C178.778 135.954 183.983 130.749 183.983 124.329V100.166C183.983 93.7458 178.778 88.541 172.358 88.541Z",
    stroke: "#484848",
    strokeWidth: 0.910926
  }))), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.656 107.55C179.656 109.538 178.003 111.15 175.963 111.15C174.244 111.15 172.798 110.003 172.387 108.45H167.233C166.33 108.45 165.561 109.086 165.412 109.955L165.261 110.843C165.119 111.664 164.694 112.409 164.061 112.95C164.679 113.481 165.117 114.216 165.261 115.058L165.411 115.946C165.488 116.371 165.714 116.756 166.048 117.031C166.382 117.307 166.802 117.455 167.235 117.45H168.697C169.107 115.898 170.553 114.75 172.273 114.75C174.313 114.75 175.965 116.363 175.965 118.35C175.965 120.338 174.31 121.95 172.273 121.95C170.553 121.95 169.108 120.803 168.697 119.25H167.235C165.429 119.25 163.89 117.978 163.593 116.243L163.441 115.355C163.364 114.929 163.139 114.545 162.805 114.27C162.472 113.995 162.052 113.846 161.62 113.85H160.111C159.649 115.326 158.242 116.4 156.577 116.4C154.912 116.4 153.505 115.326 153.045 113.85H150.882C150.42 115.326 149.013 116.4 147.349 116.4C145.309 116.4 143.656 114.788 143.656 112.8C143.656 110.813 145.309 109.2 147.349 109.2C149.124 109.2 150.607 110.423 150.961 112.05H152.967C153.321 110.423 154.804 109.2 156.579 109.2C158.355 109.2 159.837 110.423 160.191 112.05H161.619C162.52 112.05 163.291 111.414 163.438 110.546L163.591 109.658C163.888 107.922 165.429 106.65 167.233 106.65H172.387C172.798 105.098 174.244 103.95 175.963 103.95C178.003 103.95 179.656 105.563 179.656 107.55ZM177.811 107.55C177.811 108.545 176.983 109.35 175.963 109.35C174.943 109.35 174.118 108.545 174.118 107.55C174.118 106.556 174.943 105.75 175.963 105.75C176.983 105.75 177.81 106.556 177.81 107.55H177.811ZM147.348 114.6C148.368 114.6 149.193 113.795 149.193 112.8C149.193 111.806 148.368 111 147.348 111C146.328 111 145.501 111.806 145.501 112.8C145.501 113.795 146.328 114.6 147.348 114.6ZM156.577 114.6C157.597 114.6 158.424 113.795 158.424 112.8C158.424 111.806 157.599 111 156.579 111C155.559 111 154.732 111.806 154.732 112.8C154.732 113.795 155.557 114.6 156.577 114.6ZM172.27 120.15C173.29 120.15 174.115 119.345 174.115 118.35C174.115 117.356 173.29 116.55 172.27 116.55C171.25 116.55 170.425 117.356 170.425 118.35C170.425 119.345 171.25 120.15 172.27 120.15Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_345_396)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7058 58.2998H4.90243C2.44083 58.2998 0.445312 60.1832 0.445312 62.5065V71.7591C0.445312 74.0824 2.44083 75.9658 4.90243 75.9658H14.7058C17.1674 75.9658 19.1629 74.0824 19.1629 71.7591V62.5065C19.1629 60.1832 17.1674 58.2998 14.7058 58.2998Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7058 58.2998H4.90243C2.44083 58.2998 0.445312 60.1832 0.445312 62.5065V71.7591C0.445312 74.0824 2.44083 75.9658 4.90243 75.9658H14.7058C17.1674 75.9658 19.1629 74.0824 19.1629 71.7591V62.5065C19.1629 60.1832 17.1674 58.2998 14.7058 58.2998Z",
    fill: "white",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_345_396)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14_345_396)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.565 150.37H103.762C101.3 150.37 99.3047 152.255 99.3047 154.579V163.836C99.3047 166.161 101.3 168.045 103.762 168.045H113.565C116.027 168.045 118.022 166.161 118.022 163.836V154.579C118.022 152.255 116.027 150.37 113.565 150.37Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.565 150.37H103.762C101.3 150.37 99.3047 152.255 99.3047 154.579V163.836C99.3047 166.161 101.3 168.045 103.762 168.045H113.565C116.027 168.045 118.022 166.161 118.022 163.836V154.579C118.022 152.255 116.027 150.37 113.565 150.37Z",
    stroke: "#484848",
    strokeWidth: 0.864795
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15_345_396)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16_345_396)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.729 108.979H238.926C236.464 108.979 234.469 110.864 234.469 113.188V122.446C234.469 124.77 236.464 126.655 238.926 126.655H248.729C251.191 126.655 253.186 124.77 253.186 122.446V113.188C253.186 110.864 251.191 108.979 248.729 108.979Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.729 108.979H238.926C236.464 108.979 234.469 110.864 234.469 113.188V122.446C234.469 124.77 236.464 126.655 238.926 126.655H248.729C251.191 126.655 253.186 124.77 253.186 122.446V113.188C253.186 110.864 251.191 108.979 248.729 108.979Z",
    fill: "white",
    fillOpacity: 0.2
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17_345_396)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18_345_396)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.498 22.8096H215.541C211.639 22.8096 208.477 26.0659 208.477 30.0828V45.4832C208.477 49.5 211.639 52.7563 215.541 52.7563H230.498C234.399 52.7563 237.562 49.5 237.562 45.4832V30.0828C237.562 26.0659 234.399 22.8096 230.498 22.8096Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.498 22.8096H215.541C211.639 22.8096 208.477 26.0659 208.477 30.0828V45.4832C208.477 49.5 211.639 52.7563 215.541 52.7563H230.498C234.399 52.7563 237.562 49.5 237.562 45.4832V30.0828C237.562 26.0659 234.399 22.8096 230.498 22.8096Z",
    stroke: "#484848",
    strokeWidth: 0.842395
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19_345_396)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20_345_396)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0994 119.817H20.1421C16.2408 119.817 13.0781 123.073 13.0781 127.088V142.484C13.0781 146.499 16.2408 149.755 20.1421 149.755H35.0994C39.0007 149.755 42.1633 146.499 42.1633 142.484V127.088C42.1633 123.073 39.0007 119.817 35.0994 119.817Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0994 119.817H20.1421C16.2408 119.817 13.0781 123.073 13.0781 127.088V142.484C13.0781 146.499 16.2408 149.755 20.1421 149.755H35.0994C39.0007 149.755 42.1633 146.499 42.1633 142.484V127.088C42.1633 123.073 39.0007 119.817 35.0994 119.817Z",
    stroke: "#484848",
    strokeWidth: 0.842395
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21_345_396)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip22_345_396)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.2088 10.1475H60.2514C56.3501 10.1475 53.1875 13.4027 53.1875 17.4184V32.8139C53.1875 36.8295 56.3501 40.0848 60.2514 40.0848H75.2088C79.1101 40.0848 82.2727 36.8295 82.2727 32.8139V17.4184C82.2727 13.4027 79.1101 10.1475 75.2088 10.1475Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2088 10.1475H60.2514C56.3501 10.1475 53.1875 13.4027 53.1875 17.4184V32.8139C53.1875 36.8295 56.3501 40.0848 60.2514 40.0848H75.2088C79.1101 40.0848 82.2727 36.8295 82.2727 32.8139V17.4184C82.2727 13.4027 79.1101 10.1475 75.2088 10.1475Z",
    stroke: "#484848",
    strokeWidth: 0.842395
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_345_396",
    x: 0,
    y: 0,
    width: 254.494,
    height: 169.28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_345_396"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_345_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163.83,
    height: 163.41,
    fill: "white",
    transform: "translate(44.3594)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_345_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163.83,
    height: 163.41,
    fill: "white",
    transform: "translate(44.3594)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_345_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.78,
    height: 49.19,
    fill: "white",
    transform: "translate(122.938 26.1895)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_345_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.78,
    height: 49.19,
    fill: "white",
    transform: "translate(122.938 26.1895)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_345_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.19,
    height: 49.19,
    fill: "white",
    transform: "translate(122.234 26.1895)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_345_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 27,
    fill: "white",
    transform: "translate(134.656 36.9502)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_345_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.79,
    height: 49.19,
    fill: "white",
    transform: "translate(67.5859 77.7197)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_345_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.79,
    height: 49.19,
    fill: "white",
    transform: "translate(67.5859 77.7197)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_345_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.19,
    height: 49.19,
    fill: "white",
    transform: "translate(66.8828 77.7197)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_345_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.78,
    height: 49.19,
    fill: "white",
    transform: "translate(136.445 87.8594)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_345_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.78,
    height: 49.19,
    fill: "white",
    transform: "translate(136.445 87.8594)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_345_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.19,
    height: 49.19,
    fill: "white",
    transform: "translate(135.742 87.8594)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_345_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.47,
    height: 19.32,
    fill: "white",
    transform: "translate(0 57.8799)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_345_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.47,
    height: 19.33,
    fill: "white",
    transform: "translate(98.8594 149.95)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14_345_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.47,
    height: 19.33,
    fill: "white",
    transform: "translate(98.8594 149.95)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15_345_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.47,
    height: 19.33,
    fill: "white",
    transform: "translate(234.023 108.56)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16_345_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.47,
    height: 19.33,
    fill: "white",
    transform: "translate(234.023 108.56)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17_345_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.72,
    height: 31.63,
    fill: "white",
    transform: "translate(207.836 22.3896)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18_345_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.72,
    height: 31.63,
    fill: "white",
    transform: "translate(207.836 22.3896)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19_345_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.72,
    height: 31.62,
    fill: "white",
    transform: "translate(12.6641 118.689)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20_345_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.72,
    height: 31.62,
    fill: "white",
    transform: "translate(12.6641 118.689)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21_345_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.72,
    height: 31.62,
    fill: "white",
    transform: "translate(52.3828 9.71973)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22_345_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.72,
    height: 31.62,
    fill: "white",
    transform: "translate(52.3828 9.71973)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomation);
export default __webpack_public_path__ + "static/media/automation.536cfc96466acbe78a44d66e94f22413.svg";
export { ForwardRef as ReactComponent };